export enum EditorRenderStrategy {
    ReadOnly = 'read-only',
    Editable = 'editable'
}

export enum WidgetPropertyType {
    Boolean = 'boolean',
    String = 'string',
    Number = 'number'
}

export interface PropertyDef {
    key: string;
    label: string;
    type: WidgetPropertyType;
}

export interface EditorPropertySchema {
    renderStrategy: EditorRenderStrategy;
    propertySchema: PropertyDef[];
}

export function parseAttribute<T extends boolean | number | string>(value: string | null | undefined, defaultValue: T): T {
    if (value == null) return defaultValue;

    if (typeof defaultValue === 'boolean') {
        if (value === 'true') return true as T;
        if (value === 'false') return false as T;
        return defaultValue;
    }

    if (typeof defaultValue === 'number') {
        const n = Number(value);
        return (isNaN(n) ? defaultValue : n) as T;
    }

    return value as T;
}
